/*
 * fmp-hide-on-zoom.js
 * ---------------------------------------------------------------------------
 * Desktop only. The theme's hover-magnify (magnify.js) inserts a
 * <div class="image-magnify-full-size"> inside the media item while zooming and
 * removes it when the pointer leaves. That overlay sits over the image, so the
 * "Family Matching" button (.fmp-trigger-btn--desktop) steals the hover and
 * cancels the zoom.
 *
 * This watches for that overlay appearing / disappearing and toggles a class
 * ONLY on the specific media item (<li class="product__media-item">) that is
 * being zoomed — so the button is hidden only on the image currently zoomed,
 * not on every image. No changes to magnify.js needed.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var ITEM_ACTIVE_CLASS = 'fmp-zoom-active';
  var OVERLAY_SELECTOR = '.image-magnify-full-size';
  var ITEM_SELECTOR = '.product__media-item';

  function sync() {
    // Clear the marker everywhere first.
    var marked = document.querySelectorAll('.' + ITEM_ACTIVE_CLASS);
    Array.prototype.forEach.call(marked, function (el) {
      el.classList.remove(ITEM_ACTIVE_CLASS);
    });

    // Then mark only the media item(s) that currently contain a zoom overlay.
    var overlays = document.querySelectorAll(OVERLAY_SELECTOR);
    Array.prototype.forEach.call(overlays, function (overlay) {
      var item = overlay.closest(ITEM_SELECTOR);
      if (item) item.classList.add(ITEM_ACTIVE_CLASS);
    });
  }

  function start() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.addedNodes.length || m.removedNodes.length) {
          sync();
          return;
        }
      }
    });

    var targets = document.querySelectorAll('.product__media-wrapper');
    if (targets.length) {
      targets.forEach(function (t) {
        observer.observe(t, { childList: true, subtree: true });
      });
    } else {
      observer.observe(document.body, { childList: true, subtree: true });
    }
    sync();
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();